import { McpConnectionAuthModeEnum } from '../../dto/agent/managed-runtime.dto';
export const MCP_SERVERS = [
    // ── Popular ────────────────────────────────────────────────────────────────
    {
        id: 'slack',
        name: 'Slack',
        description: 'Read and send Slack messages, manage channels and workspaces.',
        url: 'https://mcp.slack.com/mcp',
        category: 'communication',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'linear',
        name: 'Linear',
        description: 'Access and manage Linear issues, projects, and cycles.',
        url: 'https://mcp.linear.app/mcp',
        category: 'productivity',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'atlassian-rovo',
        name: 'Atlassian Rovo',
        description: 'Access Jira issues and Confluence pages in one integration.',
        url: 'https://mcp.atlassian.com/v1/mcp/authv2',
        category: 'productivity',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'github',
        name: 'GitHub',
        description: 'Interact with repositories, pull requests, issues, and code.',
        url: 'https://api.githubcopilot.com/mcp/',
        category: 'code',
        popular: true,
        // GitHub does NOT advertise RFC 8414 AS metadata or RFC 7591 DCR, so the
        // catalog pins the authorize/token endpoints and Novu uses its single
        // pre-registered GitHub App (env-loaded `NOVU_GITHUB_MCP_APP_CLIENT_*`).
        // Scopes mirror Anthropic's Claude GitHub connector verbatim so users
        // see a familiar permission set on the consent screen.
        oauth: {
            mode: McpConnectionAuthModeEnum.NovuApp,
            issuer: 'https://github.com',
            authorizationEndpoint: 'https://github.com/login/oauth/authorize',
            tokenEndpoint: 'https://github.com/login/oauth/access_token',
            scopes: [
                'repo',
                'read:org',
                'read:user',
                'user:email',
                'read:packages',
                'write:packages',
                'read:project',
                'project',
                'gist',
                'notifications',
                'workflow',
                'codespace',
            ],
        },
    },
    {
        id: 'sentry',
        name: 'Sentry',
        description: 'Access error events, issues, and performance data from Sentry.',
        url: 'https://mcp.sentry.dev/mcp',
        category: 'code',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'notion',
        name: 'Notion',
        description: 'Read and write Notion pages, databases, and blocks.',
        url: 'https://mcp.notion.com/mcp',
        category: 'productivity',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'asana',
        name: 'Asana',
        description: 'Coordinate tasks, projects, and goals in Asana.',
        url: 'https://mcp.asana.com/v2/mcp',
        category: 'productivity',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'amplitude',
        name: 'Amplitude',
        description: 'Retrieve behavioral analytics and product insights from Amplitude.',
        url: 'https://mcp.amplitude.com/mcp',
        category: 'data',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'airtable',
        name: 'Airtable',
        description: 'Bring your Airtable structured data and databases to Claude.',
        url: 'https://mcp.airtable.com/mcp',
        category: 'data',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'stripe',
        name: 'Stripe',
        description: 'Query payments, customers, subscriptions, and disputes.',
        url: 'https://mcp.stripe.com',
        category: 'financial-services',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'intercom',
        name: 'Intercom',
        description: 'Access customer conversations, contacts, and support tickets.',
        url: 'https://mcp.intercom.com/mcp',
        category: 'communication',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'datadog',
        name: 'Datadog',
        description: 'Query metrics, logs, traces, and alerts from Datadog.',
        url: 'https://mcp.datadoghq.com/api/unstable/mcp-server/mcp',
        category: 'code',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'pagerduty',
        name: 'PagerDuty',
        description: 'Manage incidents, schedules, and on-call rotations in PagerDuty.',
        url: 'https://mcp.pagerduty.com/mcp',
        category: 'code',
        popular: true,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    // ── All others ─────────────────────────────────────────────────────────────
    {
        id: 'adobe-experience-manager',
        name: 'Adobe Experience Manager',
        description: 'Manage your Adobe Experience Manager content.',
        url: 'https://mcp.adobeaemcloud.com/adobe/mcp/aem',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ahrefs',
        name: 'Ahrefs',
        description: 'SEO analytics, backlinks, keywords, and AI search data.',
        url: 'https://api.ahrefs.com/mcp/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'attio',
        name: 'Attio',
        description: 'Search, manage, and update your Attio CRM from Claude.',
        url: 'https://mcp.attio.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'aws-marketplace',
        name: 'AWS Marketplace',
        description: 'Discover, evaluate, and buy cloud solutions on AWS.',
        url: 'https://marketplace-mcp.us-east-1.api.aws/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'box',
        name: 'Box',
        description: 'Access and manage files, folders, and documents in Box.',
        url: 'https://mcp.box.com',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'brex',
        name: 'Brex',
        description: 'Manage corporate cards, expenses, and budgets in Brex.',
        url: 'https://api.brex.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'canva',
        name: 'Canva',
        description: 'Create and edit designs using Canva templates and assets.',
        url: 'https://mcp.canva.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'cloudflare',
        name: 'Cloudflare',
        description: 'Manage Cloudflare DNS, Workers, and security settings.',
        url: 'https://mcp.cloudflare.com/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'dropbox',
        name: 'Dropbox',
        description: 'Access, share, and manage files stored in Dropbox.',
        url: 'https://mcp.dropbox.com/dash',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'figma',
        name: 'Figma',
        description: 'Inspect and work with Figma designs and components.',
        url: 'https://mcp.figma.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'google-drive',
        name: 'Google Drive',
        description: 'Read and manage files and folders in Google Drive.',
        url: 'https://drivemcp.googleapis.com/mcp/v1',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'hubspot',
        name: 'HubSpot',
        description: 'Access contacts, deals, companies, and marketing data from HubSpot.',
        url: 'https://mcp.hubspot.com/anthropic',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mixpanel',
        name: 'Mixpanel',
        description: 'Query product analytics and user behavior insights from Mixpanel.',
        url: 'https://mcp.mixpanel.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'neon',
        name: 'Neon',
        description: 'Interact with Neon serverless Postgres databases.',
        url: 'https://mcp.neon.tech/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'plaid',
        name: 'Plaid',
        description: 'Access financial accounts, transactions, and identity data via Plaid.',
        url: 'https://api.dashboard.plaid.com/mcp/sse',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'square',
        name: 'Square',
        description: 'Access payments, inventory, customers, and orders from Square.',
        url: 'https://mcp.squareup.com/sse',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'supabase',
        name: 'Supabase',
        description: 'Interact with Supabase databases, auth, and storage.',
        url: 'https://mcp.supabase.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.Dcr },
    },
    {
        id: 'adisinsight',
        name: 'AdisInsight',
        description: 'Connect AdisInsight to your agent via the managed runtime provider.',
        url: 'https://adisinsight-mcp.springer.com/mcp',
        category: 'health-and-wellness',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'adobe-for-creativity',
        name: 'Adobe for creativity',
        description: 'Connect Adobe for creativity to your agent via the managed runtime provider.',
        url: 'https://adobe-creativity.adobe.io/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'adobe-journey-optimizer',
        name: 'Adobe Journey Optimizer',
        description: 'Connect Adobe Journey Optimizer to your agent via the managed runtime provider.',
        url: 'https://ajo-mcp.adobe.io/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'adobe-marketing-agent',
        name: 'Adobe Marketing Agent',
        description: 'Connect Adobe Marketing Agent to your agent via the managed runtime provider.',
        url: 'https://aep-ai-ama.adobe.io/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'aiera',
        name: 'Aiera',
        description: 'Connect Aiera to your agent via the managed runtime provider.',
        url: 'https://mcp-pub.aiera.com/',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'airops',
        name: 'AirOps',
        description: 'Connect AirOps to your agent via the managed runtime provider.',
        url: 'https://app.airops.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'airwallex-developer',
        name: 'Airwallex Developer',
        description: 'Connect Airwallex Developer to your agent via the managed runtime provider.',
        url: 'https://mcp-demo.airwallex.com/developer',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'alma',
        name: 'Alma',
        description: 'Connect Alma to your agent via the managed runtime provider.',
        url: 'https://mcp.alma.food',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'apollo-io',
        name: 'Apollo.io',
        description: 'Connect Apollo.io to your agent via the managed runtime provider.',
        url: 'https://mcp.apollo.io/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'aura',
        name: 'Aura',
        description: 'Connect Aura to your agent via the managed runtime provider.',
        url: 'https://mcp.auraintelligence.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'aurora',
        name: 'Aurora',
        description: 'Connect Aurora to your agent via the managed runtime provider.',
        url: 'https://mcp.ai.consilio.com',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'base44',
        name: 'Base44',
        description: 'Connect Base44 to your agent via the managed runtime provider.',
        url: 'https://app.base44.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'bigdata-com',
        name: 'Bigdata.com',
        description: 'Connect Bigdata.com to your agent via the managed runtime provider.',
        url: 'https://mcp.bigdata.com/',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'biorender',
        name: 'BioRender',
        description: 'Connect BioRender to your agent via the managed runtime provider.',
        url: 'https://mcp.services.biorender.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'bitly',
        name: 'Bitly',
        description: 'Connect Bitly to your agent via the managed runtime provider.',
        url: 'https://api-ssl.bitly.com/v4/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'calendly',
        name: 'Calendly',
        description: 'Connect Calendly to your agent via the managed runtime provider.',
        url: 'https://mcp.calendly.com',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'campfire',
        name: 'Campfire',
        description: 'Connect Campfire to your agent via the managed runtime provider.',
        url: 'https://api.meetcampfire.com/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'candid',
        name: 'Candid',
        description: 'Connect Candid to your agent via the managed runtime provider.',
        url: 'https://mcp.candid.org/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'carta',
        name: 'Carta',
        description: 'Connect Carta to your agent via the managed runtime provider.',
        url: 'https://mcp.app.carta.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'cb-insights',
        name: 'CB Insights',
        description: 'Connect CB Insights to your agent via the managed runtime provider.',
        url: 'https://mcp.cbinsights.com',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'cdata-connect-ai',
        name: 'CData Connect AI',
        description: 'Connect CData Connect AI to your agent via the managed runtime provider.',
        url: 'https://mcp.cloud.cdata.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'chronograph',
        name: 'Chronograph',
        description: 'Connect Chronograph to your agent via the managed runtime provider.',
        url: 'https://ai.chronograph.pe/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'circleback',
        name: 'Circleback',
        description: 'Connect Circleback to your agent via the managed runtime provider.',
        url: 'https://circleback.ai/api/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'clarify',
        name: 'Clarify',
        description: 'Connect Clarify to your agent via the managed runtime provider.',
        url: 'https://api.clarify.ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'clay',
        name: 'Clay',
        description: 'Connect Clay to your agent via the managed runtime provider.',
        url: 'https://api.clay.com/v3/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'clickup',
        name: 'ClickUp',
        description: 'Connect ClickUp to your agent via the managed runtime provider.',
        url: 'https://mcp.clickup.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'close',
        name: 'Close',
        description: 'Connect Close to your agent via the managed runtime provider.',
        url: 'https://mcp.close.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'cloudflare-developer-platform',
        name: 'Cloudflare Developer Platform',
        description: 'Connect Cloudflare Developer Platform to your agent via the managed runtime provider.',
        url: 'https://bindings.mcp.cloudflare.com/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'cloudinary',
        name: 'Cloudinary',
        description: 'Connect Cloudinary to your agent via the managed runtime provider.',
        url: 'https://asset-management.mcp.cloudinary.com/sse',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'cocounsel-legal',
        name: 'CoCounsel Legal',
        description: 'Connect CoCounsel Legal to your agent via the managed runtime provider.',
        url: 'https://legal-mcp.thomsonreuters.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'coindesk',
        name: 'CoinDesk',
        description: 'Connect CoinDesk to your agent via the managed runtime provider.',
        url: 'https://mcp.coindesk.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'common-room',
        name: 'Common Room',
        description: 'Connect Common Room to your agent via the managed runtime provider.',
        url: 'https://mcp.commonroom.io/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'consensus',
        name: 'Consensus',
        description: 'Connect Consensus to your agent via the managed runtime provider.',
        url: 'https://mcp.consensus.app/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'contentsquare',
        name: 'Contentsquare',
        description: 'Connect Contentsquare to your agent via the managed runtime provider.',
        url: 'https://api.contentsquare.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'context7',
        name: 'Context7',
        description: 'Connect Context7 to your agent via the managed runtime provider.',
        url: 'https://mcp.context7.com/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'coupler-io',
        name: 'Coupler.io',
        description: 'Connect Coupler.io to your agent via the managed runtime provider.',
        url: 'https://mcp.coupler.io/mcp/',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'courtlistener',
        name: 'CourtListener',
        description: 'Connect CourtListener to your agent via the managed runtime provider.',
        url: 'https://mcp.courtlistener.com/',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'craft',
        name: 'Craft',
        description: 'Connect Craft to your agent via the managed runtime provider.',
        url: 'https://mcp.craft.do/my/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'crossbeam',
        name: 'Crossbeam',
        description: 'Connect Crossbeam to your agent via the managed runtime provider.',
        url: 'https://mcp.crossbeam.com',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'd-b-risk-analytics',
        name: 'D&B Risk Analytics',
        description: 'Connect D&B Risk Analytics to your agent via the managed runtime provider.',
        url: 'https://agents.riskanalytics.dnb.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'daloopa',
        name: 'Daloopa',
        description: 'Connect Daloopa to your agent via the managed runtime provider.',
        url: 'https://mcp.daloopa.com/server/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'datasite',
        name: 'Datasite',
        description: 'Connect Datasite to your agent via the managed runtime provider.',
        url: 'https://mcp.global.datasite.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'day-ai',
        name: 'Day AI',
        description: 'Connect Day AI to your agent via the managed runtime provider.',
        url: 'https://day.ai/api/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'definely',
        name: 'Definely',
        description: 'Connect Definely to your agent via the managed runtime provider.',
        url: 'https://mcp.app.definely.com',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'descript',
        name: 'Descript',
        description: 'Connect Descript to your agent via the managed runtime provider.',
        url: 'https://api.descript.com/v2/mcp/claude',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'descrybe-legal-engine',
        name: 'Descrybe Legal Engine',
        description: 'Connect Descrybe Legal Engine to your agent via the managed runtime provider.',
        url: 'https://mcp.descrybe.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'devrev',
        name: 'DevRev',
        description: 'Connect DevRev to your agent via the managed runtime provider.',
        url: 'https://api.devrev.ai/mcp/v1',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'digits',
        name: 'Digits',
        description: 'Connect Digits to your agent via the managed runtime provider.',
        url: 'https://api.digits.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'docuseal',
        name: 'DocuSeal',
        description: 'Connect DocuSeal to your agent via the managed runtime provider.',
        url: 'https://docuseal.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'docusign',
        name: 'Docusign',
        description: 'Connect Docusign to your agent via the managed runtime provider.',
        url: 'https://mcp.docusign.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'dovetail',
        name: 'Dovetail',
        description: 'Connect Dovetail to your agent via the managed runtime provider.',
        url: 'https://dovetail.com/api/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'egnyte',
        name: 'Egnyte',
        description: 'Connect Egnyte to your agent via the managed runtime provider.',
        url: 'https://mcp-server.egnyte.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'enterpret',
        name: 'Enterpret',
        description: 'Connect Enterpret to your agent via the managed runtime provider.',
        url: 'https://wisdom-api.enterpret.com/server/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'era-context',
        name: 'Era Context',
        description: 'Connect Era Context to your agent via the managed runtime provider.',
        url: 'https://context.era.app',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'eraser',
        name: 'Eraser',
        description: 'Connect Eraser to your agent via the managed runtime provider.',
        url: 'https://app.eraser.io/api/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'euler',
        name: 'Euler',
        description: 'Connect Euler to your agent via the managed runtime provider.',
        url: 'https://mcp.eulerapp.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'everlaw',
        name: 'Everlaw',
        description: 'Connect Everlaw to your agent via the managed runtime provider.',
        url: 'https://api.everlaw.com/v1/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'exa',
        name: 'Exa',
        description: 'Connect Exa to your agent via the managed runtime provider.',
        url: 'https://mcp.exa.ai/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'factset-ai-ready-data',
        name: 'FactSet AI-Ready Data',
        description: 'Connect FactSet AI-Ready Data to your agent via the managed runtime provider.',
        url: 'https://mcp.factset.com/content/v1',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fathom',
        name: 'Fathom',
        description: 'Connect Fathom to your agent via the managed runtime provider.',
        url: 'https://api.fathom.ai/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fellow-ai',
        name: 'Fellow.ai',
        description: 'Connect Fellow.ai to your agent via the managed runtime provider.',
        url: 'https://fellow.app/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fever-event-discovery',
        name: 'Fever Event Discovery',
        description: 'Connect Fever Event Discovery to your agent via the managed runtime provider.',
        url: 'https://data-search.apigw.feverup.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fireflies',
        name: 'Fireflies',
        description: 'Connect Fireflies to your agent via the managed runtime provider.',
        url: 'https://api.fireflies.ai/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fiscal-ai',
        name: 'Fiscal.ai',
        description: 'Connect Fiscal.ai to your agent via the managed runtime provider.',
        url: 'https://api.fiscal.ai/mcp/sse',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'fmp',
        name: 'FMP',
        description: 'Connect FMP to your agent via the managed runtime provider.',
        url: 'https://financialmodelingprep.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'g2',
        name: 'G2',
        description: 'Connect G2 to your agent via the managed runtime provider.',
        url: 'https://mcp.g2.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'gainsight',
        name: 'Gainsight (Staircase AI)',
        description: 'Connect Gainsight (Staircase AI) to your agent via the managed runtime provider.',
        url: 'https://mcp.staircase.ai/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'gamma',
        name: 'Gamma',
        description: 'Connect Gamma to your agent via the managed runtime provider.',
        url: 'https://mcp.gamma.app/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'gmail',
        name: 'Gmail',
        description: 'Connect Gmail to your agent via the managed runtime provider.',
        url: 'https://gmailmcp.googleapis.com/mcp/v1',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'google-calendar',
        name: 'Google Calendar',
        description: 'Connect Google Calendar to your agent via the managed runtime provider.',
        url: 'https://calendarmcp.googleapis.com/mcp/v1',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'google-cloud-bigquery',
        name: 'Google Cloud BigQuery',
        description: 'Connect Google Cloud BigQuery to your agent via the managed runtime provider.',
        url: 'https://bigquery.googleapis.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'google-compute-engine',
        name: 'Google Compute Engine',
        description: 'Connect Google Compute Engine to your agent via the managed runtime provider.',
        url: 'https://compute.googleapis.com/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'govtribe',
        name: 'GovTribe',
        description: 'Connect GovTribe to your agent via the managed runtime provider.',
        url: 'https://govtribe.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'grain',
        name: 'Grain',
        description: 'Connect Grain to your agent via the managed runtime provider.',
        url: 'https://api.grain.com/_/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'granola',
        name: 'Granola',
        description: 'Connect Granola to your agent via the managed runtime provider.',
        url: 'https://mcp.granola.ai/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'guidepoint',
        name: 'Guidepoint',
        description: 'Connect Guidepoint to your agent via the managed runtime provider.',
        url: 'https://clapi.guidepoint.io/mcp-server/v1/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'guru',
        name: 'Guru',
        description: 'Connect Guru to your agent via the managed runtime provider.',
        url: 'https://mcp.api.getguru.com/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'gusto',
        name: 'Gusto',
        description: 'Connect Gusto to your agent via the managed runtime provider.',
        url: 'https://mcp.api.gusto.com/anthropic',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'harmonic',
        name: 'Harmonic',
        description: 'Connect Harmonic to your agent via the managed runtime provider.',
        url: 'https://mcp.api.harmonic.ai',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'harness-io',
        name: 'Harness.io',
        description: 'Connect Harness.io to your agent via the managed runtime provider.',
        url: 'https://mcp.harness.io/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'harvey',
        name: 'Harvey',
        description: 'Connect Harvey to your agent via the managed runtime provider.',
        url: 'https://api.harvey.ai/hosted_mcp/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'honeycomb',
        name: 'Honeycomb',
        description: 'Connect Honeycomb to your agent via the managed runtime provider.',
        url: 'https://mcp.honeycomb.io/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'hugging-face',
        name: 'Hugging Face',
        description: 'Connect Hugging Face to your agent via the managed runtime provider.',
        url: 'https://huggingface.co/mcp?login&gradio=none',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ibisworld',
        name: 'IBISWorld',
        description: 'Connect IBISWorld to your agent via the managed runtime provider.',
        url: 'https://mcp.ibisworld.com',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ice-data-services',
        name: 'ICE Data Services',
        description: 'Connect ICE Data Services to your agent via the managed runtime provider.',
        url: 'https://fids-mcp.ice.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ifttt',
        name: 'IFTTT',
        description: 'Connect IFTTT to your agent via the managed runtime provider.',
        url: 'https://ifttt.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'imanage-work',
        name: 'iManage Work',
        description: 'Connect iManage Work to your agent via the managed runtime provider.',
        url: 'https://cloudimanage.com/mcp/work',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'incident-io',
        name: 'incident.io',
        description: 'Connect incident.io to your agent via the managed runtime provider.',
        url: 'https://mcp.incident.io/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'indeed',
        name: 'Indeed',
        description: 'Connect Indeed to your agent via the managed runtime provider.',
        url: 'https://mcp.indeed.com/claude/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'instacart',
        name: 'Instacart',
        description: 'Connect Instacart to your agent via the managed runtime provider.',
        url: 'https://fig-mcp.instacart.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'interactive-brokers',
        name: 'Interactive Brokers (IBKR)',
        description: 'Connect Interactive Brokers (IBKR) to your agent via the managed runtime provider.',
        url: 'https://api.ibkr.com/v1/api/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'intuit-credit-karma',
        name: 'Intuit Credit Karma',
        description: 'Connect Intuit Credit Karma to your agent via the managed runtime provider.',
        url: 'https://anthropic.mcp.creditkarma.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'intuit-mailchimp',
        name: 'Intuit Mailchimp',
        description: 'Connect Intuit Mailchimp to your agent via the managed runtime provider.',
        url: 'https://ai-inc.mailchimp.com/claude/mcp/v2',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'intuit-turbotax',
        name: 'Intuit TurboTax',
        description: 'Connect Intuit TurboTax to your agent via the managed runtime provider.',
        url: 'https://ai-inc.turbotax.intuit.com/358A1C1B-F73B-46A7-B130-4B14916E6843/v1/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ironclad-contracts',
        name: 'Ironclad Contracts',
        description: 'Connect Ironclad Contracts to your agent via the managed runtime provider.',
        url: 'https://mcp.na1.ironcladapp.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'jam',
        name: 'Jam',
        description: 'Connect Jam to your agent via the managed runtime provider.',
        url: 'https://mcp.jam.dev/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'jentic',
        name: 'Jentic',
        description: 'Connect Jentic to your agent via the managed runtime provider.',
        url: 'https://api.jentic.com/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'jotform',
        name: 'Jotform',
        description: 'Connect Jotform to your agent via the managed runtime provider.',
        url: 'https://mcp.jotform.com/mcp-app',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ketryx',
        name: 'Ketryx',
        description: 'Connect Ketryx to your agent via the managed runtime provider.',
        url: 'https://app.ketryx.com/api/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'klarity',
        name: 'Klarity',
        description: 'Connect Klarity to your agent via the managed runtime provider.',
        url: 'https://architect-v2-api.klarity.ai/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'klaviyo',
        name: 'Klaviyo',
        description: 'Connect Klaviyo to your agent via the managed runtime provider.',
        url: 'https://mcp.klaviyo.com/mcp?include-mcp-app=true',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'krisp',
        name: 'Krisp',
        description: 'Connect Krisp to your agent via the managed runtime provider.',
        url: 'https://mcp.krisp.ai/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lawve-ai',
        name: 'Lawve AI',
        description: 'Connect Lawve AI to your agent via the managed runtime provider.',
        url: 'https://mcp.lawve.ai/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'legal-data-hunter',
        name: 'Legal Data Hunter',
        description: 'Connect Legal Data Hunter to your agent via the managed runtime provider.',
        url: 'https://legaldatahunter.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'legalzoom',
        name: 'LegalZoom',
        description: 'Connect LegalZoom to your agent via the managed runtime provider.',
        url: 'https://www.legalzoom.com/mcp/claude/v1',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lilt',
        name: 'LILT',
        description: 'Connect LILT to your agent via the managed runtime provider.',
        url: 'https://mcp.lilt.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'local-falcon',
        name: 'Local Falcon',
        description: 'Connect Local Falcon to your agent via the managed runtime provider.',
        url: 'https://mcp.localfalcon.com',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lorikeet',
        name: 'Lorikeet',
        description: 'Connect Lorikeet to your agent via the managed runtime provider.',
        url: 'https://mcp.lorikeetcx.ai',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lseg',
        name: 'LSEG',
        description: 'Connect LSEG to your agent via the managed runtime provider.',
        url: 'https://api.analytics.lseg.com/lfa/mcp/server-cl',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lucid',
        name: 'Lucid',
        description: 'Connect Lucid to your agent via the managed runtime provider.',
        url: 'https://mcp.lucid.app/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lumin',
        name: 'Lumin',
        description: 'Connect Lumin to your agent via the managed runtime provider.',
        url: 'https://mcp.luminpdf.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lunarcrush',
        name: 'LunarCrush',
        description: 'Connect LunarCrush to your agent via the managed runtime provider.',
        url: 'https://lunarcrush.ai/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'lusha',
        name: 'Lusha',
        description: 'Connect Lusha to your agent via the managed runtime provider.',
        url: 'https://mcp.lusha.com/mcp/claude',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'magic-patterns',
        name: 'Magic Patterns',
        description: 'Connect Magic Patterns to your agent via the managed runtime provider.',
        url: 'https://mcp.magicpatterns.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mailerlite',
        name: 'MailerLite',
        description: 'Connect MailerLite to your agent via the managed runtime provider.',
        url: 'https://mcp.mailerlite.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'make',
        name: 'Make',
        description: 'Connect Make to your agent via the managed runtime provider.',
        url: 'https://mcp.make.com',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'medidata',
        name: 'Medidata',
        description: 'Connect Medidata to your agent via the managed runtime provider.',
        url: 'https://mcp.imedidata.com/mcp',
        category: 'health-and-wellness',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'melon',
        name: 'Melon',
        description: 'Connect Melon to your agent via the managed runtime provider.',
        url: 'https://mcp.melon.com/mcp/',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mem',
        name: 'Mem',
        description: 'Connect Mem to your agent via the managed runtime provider.',
        url: 'https://mcp.mem.ai/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mercury',
        name: 'Mercury',
        description: 'Connect Mercury to your agent via the managed runtime provider.',
        url: 'https://mcp.mercury.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'metaview',
        name: 'Metaview',
        description: 'Connect Metaview to your agent via the managed runtime provider.',
        url: 'https://mcp.metaview.ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'microsoft-365',
        name: 'Microsoft 365',
        description: 'Connect Microsoft 365 to your agent via the managed runtime provider.',
        url: 'https://microsoft365.mcp.claude.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'midpage-legal-research',
        name: 'Midpage Legal Research',
        description: 'Connect Midpage Legal Research to your agent via the managed runtime provider.',
        url: 'https://app.midpage.ai/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mintlify',
        name: 'Mintlify',
        description: 'Connect Mintlify to your agent via the managed runtime provider.',
        url: 'https://mcp.mintlify.com',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'miro',
        name: 'Miro',
        description: 'Connect Miro to your agent via the managed runtime provider.',
        url: 'https://mcp.miro.com/',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'monday-com',
        name: 'monday.com',
        description: 'Connect monday.com to your agent via the managed runtime provider.',
        url: 'https://mcp.monday.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'monte-carlo',
        name: 'Monte Carlo',
        description: 'Connect Monte Carlo to your agent via the managed runtime provider.',
        url: 'https://mcp.getmontecarlo.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'moodys',
        name: "Moody's",
        description: "Connect Moody's to your agent via the managed runtime provider.",
        url: 'https://api.moodys.com/genai-ready-data/m1/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'morningstar',
        name: 'Morningstar',
        description: 'Connect Morningstar to your agent via the managed runtime provider.',
        url: 'https://mcp.morningstar.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'motherduck',
        name: 'MotherDuck',
        description: 'Connect MotherDuck to your agent via the managed runtime provider.',
        url: 'https://api.motherduck.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'motion-creative-analytics',
        name: 'Motion Creative Analytics',
        description: 'Connect Motion Creative Analytics to your agent via the managed runtime provider.',
        url: 'https://projects.motionapp.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'msci',
        name: 'MSCI',
        description: 'Connect MSCI to your agent via the managed runtime provider.',
        url: 'https://mcp.msci.com/mcp/v1.0/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'mt-newswires',
        name: 'MT Newswires',
        description: 'Connect MT Newswires to your agent via the managed runtime provider.',
        url: 'https://vast-mcp.blueskyapi.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'netdocuments',
        name: 'NetDocuments',
        description: 'Connect NetDocuments to your agent via the managed runtime provider.',
        url: 'https://web-api.us.netdocuments.app/connect/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'netlify',
        name: 'Netlify',
        description: 'Connect Netlify to your agent via the managed runtime provider.',
        url: 'https://netlify-mcp.netlify.app/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'omni-analytics',
        name: 'Omni Analytics',
        description: 'Connect Omni Analytics to your agent via the managed runtime provider.',
        url: 'https://callbacks.omniapp.co/callback/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'orion-by-gravity',
        name: 'Orion by Gravity',
        description: 'Connect Orion by Gravity to your agent via the managed runtime provider.',
        url: 'https://g.runorion.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'otter-ai',
        name: 'Otter.ai',
        description: 'Connect Otter.ai to your agent via the managed runtime provider.',
        url: 'https://mcp.otter.ai/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'outreach',
        name: 'Outreach',
        description: 'Connect Outreach to your agent via the managed runtime provider.',
        url: 'https://api.outreach.io/mcp/',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'owkin',
        name: 'Owkin',
        description: 'Connect Owkin to your agent via the managed runtime provider.',
        url: 'https://mcp.k.owkin.com/mcp',
        category: 'health-and-wellness',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'pandadoc',
        name: 'PandaDoc',
        description: 'Connect PandaDoc to your agent via the managed runtime provider.',
        url: 'https://mcp.pandadoc.com/v1/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'paypal',
        name: 'PayPal',
        description: 'Connect PayPal to your agent via the managed runtime provider.',
        url: 'https://mcp.paypal.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'pdf-viewer',
        name: 'PDF Viewer',
        description: 'Connect PDF Viewer to your agent via the managed runtime provider.',
        url: 'https://example-server.modelcontextprotocol.io/pdf/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'peec-ai',
        name: 'Peec AI',
        description: 'Connect Peec AI to your agent via the managed runtime provider.',
        url: 'https://api.peec.ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'phoenix-by-hg-insights',
        name: 'Phoenix by HG Insights',
        description: 'Connect Phoenix by HG Insights to your agent via the managed runtime provider.',
        url: 'https://phoenix.hginsights.com/api/ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'pitchbook-premium',
        name: 'PitchBook Premium',
        description: 'Connect PitchBook Premium to your agent via the managed runtime provider.',
        url: 'https://premium.mcp.pitchbook.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'planetscale',
        name: 'PlanetScale',
        description: 'Connect PlanetScale to your agent via the managed runtime provider.',
        url: 'https://mcp.pscale.dev/mcp/planetscale',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'play-sheet-music',
        name: 'Play Sheet Music',
        description: 'Connect Play Sheet Music to your agent via the managed runtime provider.',
        url: 'https://example-server.modelcontextprotocol.io/sheet-music/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'playmcp',
        name: 'PlayMCP',
        description: 'Connect PlayMCP to your agent via the managed runtime provider.',
        url: 'https://playmcp.kakao.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'polar-analytics',
        name: 'Polar Analytics',
        description: 'Connect Polar Analytics to your agent via the managed runtime provider.',
        url: 'https://api.polaranalytics.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'posthog',
        name: 'PostHog',
        description: 'Connect PostHog to your agent via the managed runtime provider.',
        url: 'https://mcp.posthog.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'postman',
        name: 'Postman',
        description: 'Connect Postman to your agent via the managed runtime provider.',
        url: 'https://mcp.postman.com/minimal',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'privacy-com',
        name: 'Privacy.com',
        description: 'Connect Privacy.com to your agent via the managed runtime provider.',
        url: 'https://mcp.privacy.com',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'process-street',
        name: 'Process Street',
        description: 'Connect Process Street to your agent via the managed runtime provider.',
        url: 'https://mcp.process.st',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'pylon',
        name: 'Pylon',
        description: 'Connect Pylon to your agent via the managed runtime provider.',
        url: 'https://mcp.usepylon.com/',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'quartr',
        name: 'Quartr',
        description: 'Connect Quartr to your agent via the managed runtime provider.',
        url: 'https://mcp.quartr.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'quo',
        name: 'Quo',
        description: 'Connect Quo to your agent via the managed runtime provider.',
        url: 'https://mcp.quo.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ramp',
        name: 'Ramp',
        description: 'Connect Ramp to your agent via the managed runtime provider.',
        url: 'https://ramp-mcp-remote.ramp.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'razorpay',
        name: 'Razorpay',
        description: 'Connect Razorpay to your agent via the managed runtime provider.',
        url: 'https://mcp.razorpay.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'read-ai',
        name: 'Read AI',
        description: 'Connect Read AI to your agent via the managed runtime provider.',
        url: 'https://api.read.ai/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'resy',
        name: 'Resy',
        description: 'Connect Resy to your agent via the managed runtime provider.',
        url: 'https://apigw.americanexpress.com/dining/v1/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'rillet',
        name: 'Rillet',
        description: 'Connect Rillet to your agent via the managed runtime provider.',
        url: 'https://api.rillet.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 's-p-global',
        name: 'S&P Global',
        description: 'Connect S&P Global to your agent via the managed runtime provider.',
        url: 'https://kfinance.kensho.com/integrations/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'sanity',
        name: 'Sanity',
        description: 'Connect Sanity to your agent via the managed runtime provider.',
        url: 'https://mcp.sanity.io',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'scholar-gateway',
        name: 'Scholar Gateway',
        description: 'Connect Scholar Gateway to your agent via the managed runtime provider.',
        url: 'https://connector.scholargateway.ai/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'scite',
        name: 'Scite',
        description: 'Connect Scite to your agent via the managed runtime provider.',
        url: 'https://api.scite.ai/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'semrush',
        name: 'Semrush',
        description: 'Connect Semrush to your agent via the managed runtime provider.',
        url: 'https://mcp.semrush.com/claude/v1/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'send',
        name: 'Send',
        description: 'Connect Send to your agent via the managed runtime provider.',
        url: 'https://www.send.co/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'shapes',
        name: 'Shapes',
        description: 'Connect Shapes to your agent via the managed runtime provider.',
        url: 'https://mcp.shapes.co/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'shopify',
        name: 'Shopify',
        description: 'Connect Shopify to your agent via the managed runtime provider.',
        url: 'https://setup.shopify.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'signnow',
        name: 'SignNow',
        description: 'Connect SignNow to your agent via the managed runtime provider.',
        url: 'https://mcp-server.signnow.com/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'similarweb',
        name: 'Similarweb',
        description: 'Connect Similarweb to your agent via the managed runtime provider.',
        url: 'https://mcp.similarweb.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'solve-intelligence',
        name: 'Solve Intelligence',
        description: 'Connect Solve Intelligence to your agent via the managed runtime provider.',
        url: 'https://api.solveintelligence.com/mcp/',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'splice',
        name: 'Splice',
        description: 'Connect Splice to your agent via the managed runtime provider.',
        url: 'https://mcp.splice.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'sprouts-data-intelligence',
        name: 'Sprouts Data Intelligence',
        description: 'Connect Sprouts Data Intelligence to your agent via the managed runtime provider.',
        url: 'https://sprouts-mcp-server.kartikay-dhar.workers.dev',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'stytch',
        name: 'Stytch',
        description: 'Connect Stytch to your agent via the managed runtime provider.',
        url: 'https://mcp.stytch.dev/mcp',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'superhuman-mail',
        name: 'Superhuman Mail',
        description: 'Connect Superhuman Mail to your agent via the managed runtime provider.',
        url: 'https://mcp.mail.superhuman.com/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'supermetrics-marketing-analytics',
        name: 'Supermetrics Marketing Analytics',
        description: 'Connect Supermetrics Marketing Analytics to your agent via the managed runtime provider.',
        url: 'https://mcp.supermetrics.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'surveymonkey',
        name: 'SurveyMonkey',
        description: 'Connect SurveyMonkey to your agent via the managed runtime provider.',
        url: 'https://mcp.surveymonkey.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'sybill',
        name: 'Sybill',
        description: 'Connect Sybill to your agent via the managed runtime provider.',
        url: 'https://mcp.sybill.ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'synapse-org',
        name: 'Synapse.org',
        description: 'Connect Synapse.org to your agent via the managed runtime provider.',
        url: 'https://mcp.synapse.org/mcp',
        category: 'health-and-wellness',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'synthesize-bio',
        name: 'Synthesize Bio',
        description: 'Connect Synthesize Bio to your agent via the managed runtime provider.',
        url: 'https://app.synthesize.bio/api/mcp',
        category: 'health-and-wellness',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'tango',
        name: 'Tango',
        description: 'Connect Tango to your agent via the managed runtime provider.',
        url: 'https://govcon.dev/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'tavily',
        name: 'Tavily',
        description: 'Connect Tavily to your agent via the managed runtime provider.',
        url: 'https://mcp.tavily.com/mcp',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'third-bridge',
        name: 'Third Bridge',
        description: 'Connect Third Bridge to your agent via the managed runtime provider.',
        url: 'https://ai.thirdbridge.com/mcp/sse',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'thoughtspot-spotter',
        name: 'ThoughtSpot Spotter',
        description: 'Connect ThoughtSpot Spotter to your agent via the managed runtime provider.',
        url: 'https://agent.thoughtspot.app/mcp?api-version=latest',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'three-js-3d-viewer',
        name: 'Three.js 3D Viewer',
        description: 'Connect Three.js 3D Viewer to your agent via the managed runtime provider.',
        url: 'https://example-server.modelcontextprotocol.io/threejs/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'ticket-tailor',
        name: 'Ticket Tailor',
        description: 'Connect Ticket Tailor to your agent via the managed runtime provider.',
        url: 'https://mcp.tickettailor.ai/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'tldv',
        name: 'tldv',
        description: 'Connect tldv to your agent via the managed runtime provider.',
        url: 'https://mcp.tldv.io/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'todoist',
        name: 'Todoist',
        description: 'Connect Todoist to your agent via the managed runtime provider.',
        url: 'https://ai.todoist.net/mcp',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'topcounsel-by-the-l-suite',
        name: 'TopCounsel by The L Suite',
        description: 'Connect TopCounsel by The L Suite to your agent via the managed runtime provider.',
        url: 'https://api.techgc.co/api/mcp/topcounsel',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'trellis',
        name: 'Trellis',
        description: 'Connect Trellis to your agent via the managed runtime provider.',
        url: 'https://mcp.trellis.law/anthropic',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'trimble-sketchup',
        name: 'Trimble SketchUp',
        description: 'Connect Trimble SketchUp to your agent via the managed runtime provider.',
        url: 'https://api.sketchup.com/mcp/v1/sketchup/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'tropic',
        name: 'Tropic',
        description: 'Connect Tropic to your agent via the managed runtime provider.',
        url: 'https://app.tropicapp.io/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'udemy-business',
        name: 'Udemy Business',
        description: 'Connect Udemy Business to your agent via the managed runtime provider.',
        url: 'https://api.udemy.com/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'unthread',
        name: 'Unthread',
        description: 'Connect Unthread to your agent via the managed runtime provider.',
        url: 'https://app.unthread.io/api/mcp',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'vercel',
        name: 'Vercel',
        description: 'Connect Vercel to your agent via the managed runtime provider.',
        url: 'https://mcp.vercel.com/',
        category: 'code',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'verisk-underwriting-intelligence',
        name: 'Verisk Underwriting Intelligence',
        description: 'Connect Verisk Underwriting Intelligence to your agent via the managed runtime provider.',
        url: 'https://gatewaymcp.verisk.com/underwriting/intelligencemcp/v1',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'verisk-xactrestore',
        name: 'Verisk XactRestore',
        description: 'Connect Verisk XactRestore to your agent via the managed runtime provider.',
        url: 'https://xactrestore-xactremodelserver-usw2-prod.propsol.io/mcp',
        category: 'other',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'vibe-prospecting',
        name: 'Vibe Prospecting',
        description: 'Connect Vibe Prospecting to your agent via the managed runtime provider.',
        url: 'https://vibeprospecting.explorium.ai/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'webflow',
        name: 'Webflow',
        description: 'Connect Webflow to your agent via the managed runtime provider.',
        url: 'https://mcp.webflow.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'windsor-ai',
        name: 'Windsor.ai',
        description: 'Connect Windsor.ai to your agent via the managed runtime provider.',
        url: 'https://mcp.windsor.ai',
        category: 'data',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'wix',
        name: 'Wix',
        description: 'Connect Wix to your agent via the managed runtime provider.',
        url: 'https://mcp.wix.com/mcp',
        category: 'design',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'wordpress-com',
        name: 'WordPress.com',
        description: 'Connect WordPress.com to your agent via the managed runtime provider.',
        url: 'https://public-api.wordpress.com/wpcom/v2/mcp/v1',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'workable',
        name: 'Workable',
        description: 'Connect Workable to your agent via the managed runtime provider.',
        url: 'https://mcp.workable.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'xero',
        name: 'Xero',
        description: 'Connect Xero to your agent via the managed runtime provider.',
        url: 'https://mcp.xero.com/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'yardi-virtuoso',
        name: 'Yardi Virtuoso',
        description: 'Connect Yardi Virtuoso to your agent via the managed runtime provider.',
        url: 'https://mcp.virtuoso.ai/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zapier',
        name: 'Zapier',
        description: 'Connect Zapier to your agent via the managed runtime provider.',
        url: 'https://mcp.zapier.com/api/v1/connect',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zocks',
        name: 'Zocks',
        description: 'Connect Zocks to your agent via the managed runtime provider.',
        url: 'https://mcp.zocks.io/v1/mcp',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoho-books',
        name: 'Zoho Books',
        description: 'Connect Zoho Books to your agent via the managed runtime provider.',
        url: 'https://claude-zohobooks.zohomcp.com/mcp/message',
        category: 'financial-services',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoho-crm',
        name: 'Zoho CRM',
        description: 'Connect Zoho CRM to your agent via the managed runtime provider.',
        url: 'https://claude-zohocrm.zohomcp.com/mcp/message',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoho-desk',
        name: 'Zoho Desk',
        description: 'Connect Zoho Desk to your agent via the managed runtime provider.',
        url: 'https://claude-zohodesk.zohomcp.com/mcp/message',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoho-projects',
        name: 'Zoho Projects',
        description: 'Connect Zoho Projects to your agent via the managed runtime provider.',
        url: 'https://claude-zohoprojects.zohomcp.com/mcp/message',
        category: 'productivity',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoom-for-claude',
        name: 'Zoom for Claude',
        description: 'Connect Zoom for Claude to your agent via the managed runtime provider.',
        url: 'https://mcp.zoom.us/mcp/zoom/streamable',
        category: 'communication',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
    {
        id: 'zoominfo',
        name: 'ZoomInfo',
        description: 'Connect ZoomInfo to your agent via the managed runtime provider.',
        url: 'https://mcp.zoominfo.com/mcp',
        category: 'sales-and-marketing',
        popular: false,
        oauth: { mode: McpConnectionAuthModeEnum.ProviderManaged },
    },
];
export const POPULAR_MCP_SERVERS = MCP_SERVERS.filter((s) => s.popular);
export const MCP_ICON_DEFAULT_ID = 'default';
export const MCP_ICON_BASE_PATH = '/agents/mcp';
export function getMcpIconPath(mcpId) {
    return `${MCP_ICON_BASE_PATH}/${mcpId}.png`;
}
export function getMcpIconUrl(mcpId, baseUrl) {
    const normalizedBase = baseUrl.replace(/\/$/, '');
    return `${normalizedBase}${getMcpIconPath(mcpId)}`;
}
export function resolveMcpCatalogIdByName(name) {
    if (!name) {
        return undefined;
    }
    const byName = MCP_SERVERS.find((entry) => entry.name === name);
    if (byName) {
        return byName.id;
    }
    const byId = MCP_SERVERS.find((entry) => entry.id === name);
    return byId?.id;
}
//# sourceMappingURL=mcp-servers.js.map